import { PencilSquare, PlusCircleFill } from 'react-bootstrap-icons';
import { useEnterpriseStore } from '../../stores/enterprise.store';
import ListGroup from 'react-bootstrap/ListGroup';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export const MdmPolicyList = () => {
  const enterprise = useEnterpriseStore((state) => state.enterprise);
  const navigate = useNavigate();

  function getPolicyName(policyId: string) {
    return policyId.replace(`${enterprise?.name}/`, '').replace('policies/', '');
  }

  console.log(enterprise);
  return (
    <section className="p-5">
      <div className="font-bold mb-4">MDM Policies</div>
      <div className="flex flex-col items-start w-fit">
        <div className="flex items-center justify-end w-full gap-2">
          <Button onClick={() => navigate('/operators/mdmpolicy')} className="flex gap-2 items-center">
            <span>New</span>
            <PlusCircleFill></PlusCircleFill>
          </Button>
        </div>
        {enterprise?.policies?.map((policy: any) => (
          <ListGroup key={policy.id} className="w-full cursor-pointer">
            <ListGroup.Item className="mt-3">
              <div className="flex items-center justify-between gap-2">
                <span>{getPolicyName(policy.name)}</span>
                <PencilSquare></PencilSquare>
              </div>
            </ListGroup.Item>
          </ListGroup>
        ))}
      </div>
    </section>
  );
};
